import React, { useState } from "react";

interface TableData {
  headers: string[];
  rows: string[][];
}

export function TablePaste() {
  const [tableData, setTableData] = useState<TableData | null>(null);

  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const rows = pastedText.split("\n").filter((row) => row.trim());

    if (rows.length > 0) {
      const parsedRows = rows.map((row) => row.split(/\t|\s{2,}/));
      const headers = parsedRows[0];
      const dataRows = parsedRows.slice(1);

      setTableData({
        headers,
        rows: dataRows,
      });
    }
  };

  const convertToString = (data: TableData): string => {
    const headerString = data.headers.join("\t");
    const rowsString = data.rows.map((row) => row.join("\t")).join("\n");
    return `${headerString}\n${rowsString}`;
  };

  const handleSendToBackend = () => {
    if (tableData) {
      const stringData = convertToString(tableData);
      console.log("Sending string data to backend:", stringData);
    }
  };

  return (
    <div className="w-full py-4">
      <div className="mb-6">
        <strong className="block mb-2 text-md bg-[#bbd0ce] p-2 pl-4 rounded-sm mt-5">
          Table Data Import
        </strong>
        <textarea
          className="w-full h-14 p-4 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Paste your table data here..."
          onPaste={handlePaste}
        />
      </div>

      {tableData && (
        <div className="space-y-4">
          <div className="bg-white rounded-lg shadow">
            <div className="relative max-h-[500px] overflow-hidden">
              <div className="overflow-x-auto">
                <div className="overflow-y-auto max-h-[500px]">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-50 sticky top-0 z-20 ">
                        <th className="sticky left-0 z-30 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50 border-b border-r border-gray-200">
                          #
                        </th>
                        {tableData.headers.map((header, index) => (
                          <th
                            key={index}
                            className="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider bg-gray-50 border-b border-gray-200 whitespace-nowrap font-bold"
                          >
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      {tableData.rows.map((row, rowIndex) => (
                        <tr key={rowIndex} className="border-b border-gray-200">
                          <td className="sticky left-0 z-10 px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-700 bg-white border-r border-gray-200">
                            {rowIndex + 1}
                          </td>
                          {row.map((cell, cellIndex) => (
                            <td
                              key={cellIndex}
                              className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-r border-gray-200"
                            >
                              {cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleSendToBackend}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Send to Backend
          </button>
        </div>
      )}
    </div>
  );
}
